module.exports = __webpack_public_path__ + "img/clockImg.6a5b212a.png";